import { createUseStyles } from 'react-jss';

const styles = {
  guidelinesContent: {
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    padding: ' 0 4rem 4rem',
  },
  typeTitle: {
    marginTop: '3rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
